import React from 'react';
import styled from 'styled-components';

// Styling for the about section
const AboutWrapper = styled.section`
  padding: 60px 20px;
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
`;

// Title styling
const AboutTitle = styled.h1`
  font-size: 3rem;
  color: #0070c9; /* Accent color for a professional touch */
  margin-bottom: 30px;
  font-weight: bold;
`;

// Text styling
const AboutText = styled.p`
  font-size: 1.3rem;
  line-height: 1.8;
  color: #333;
  margin-bottom: 30px;
`;

// History section styling
const HistoryWrapper = styled.div`
  margin: 50px 0;
  text-align: left;
`;

// History section title
const HistoryTitle = styled.h2`
  font-size: 2rem;
  color: #0070c9;
  margin-bottom: 20px;
`;

// History content
const HistoryText = styled.p`
  font-size: 1.2rem;
  line-height: 1.8;
  color: #555;
  margin-bottom: 30px;
`;

// Milestone section for visual storytelling
const Milestone = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  text-align: left;
`;

// Individual milestone styling
const MilestoneTitle = styled.h3`
  font-size: 1.5rem;
  color: #333;
  font-weight: bold;
  margin-bottom: 10px;
`;

const MilestoneText = styled.p`
  font-size: 1.1rem;
  color: #666;
  line-height: 1.6;
`;

// Call to action button styling
const ContactButton = styled.a`
  display: inline-block;
  padding: 15px 30px;
  background-color: #0070c9;
  color: white;
  font-size: 1.2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: bold;
  margin-top: 40px;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #005fa3;
  }
`;

const About = () => (
  <AboutWrapper>
    <AboutTitle>About Cloudetica Solutions</AboutTitle>
    
    <AboutText>
      At Cloudetica Solutions, we are passionate about helping businesses harness the power of the cloud. Our reputation for delivering 
      scalable, secure, and innovative solutions on AWS, Microsoft Azure, and Google Cloud has made us a trusted partner to clients across the globe.
      With years of hands-on experience and a track record of excellence, we are committed to pushing the boundaries of what's possible in the cloud space.
    </AboutText>

    <HistoryWrapper>
      <HistoryTitle>Our Journey</HistoryTitle>
      
      <HistoryText>
        Cloudetica Solutions has grown from a focused cloud consulting firm into a global leader in cloud strategy and implementation. 
        From our early projects, which revolutionized small businesses, to large-scale cloud transformations for enterprises, 
        we have consistently delivered results that drive innovation and operational efficiency.
      </HistoryText>

      <Milestone>
        <MilestoneTitle>Major Milestones</MilestoneTitle>
        <MilestoneText>
          Our approach has always been grounded in understanding our clients' needs and delivering custom-tailored solutions that scale with their business.
          Over the years, we have:
        </MilestoneText>
      </Milestone>

      <Milestone>
        <MilestoneTitle>Global Expansion</MilestoneTitle>
        <MilestoneText>
          As our reputation grew, so did our reach. We expanded our presence internationally, partnering with businesses across Europe, North America, 
          and Asia to deliver cloud excellence. Our global footprint enables us to support organizations no matter where they operate, providing round-the-clock expertise.
        </MilestoneText>
      </Milestone>

      <Milestone>
        <MilestoneTitle>Industry Leadership in Cloud Transformation</MilestoneTitle>
        <MilestoneText>
          Through our experience working with leading companies, we pioneered innovative cloud strategies, from AI-driven cloud automation to cutting-edge data analytics solutions.
          Our expertise in optimizing cloud costs and maximizing performance has empowered businesses to scale faster and achieve unparalleled efficiency.
        </MilestoneText>
      </Milestone>

      <Milestone>
        <MilestoneTitle>Certified Expertise</MilestoneTitle>
        <MilestoneText>
          Every member of our development and solutions architect teams holds relevant certifications for the cloud platforms they work on. 
          For AWS projects, our team members are AWS Certified, ensuring that they have the expertise to design, deploy, and manage highly scalable solutions. 
          Similarly, for Azure and Google Cloud projects, our experts are certified in the respective platforms, guaranteeing that our clients receive 
          top-tier service from fully accredited professionals.
        </MilestoneText>
      </Milestone>
    </HistoryWrapper>

    <AboutText>
      Our mission is clear: to help businesses of all sizes leverage the power of the cloud to drive growth, efficiency, and innovation. 
      We tailor every solution to meet our clients' unique needs and deliver results that align with their business goals.
    </AboutText>

    <ContactButton href="/contact">Get in Touch</ContactButton>
  </AboutWrapper>
);

export default About;
